import React from 'react'
import { Routes, Route } from "react-router-dom";
import Home from '../Content/Home';
import ShareResume from '../Content/ShareResume';

const MainNavigator = () => {
    return (
        <Routes>
            <Route path="*" element={<Home />}></Route>
            <Route path="/" element={<Home />}></Route>
            <Route path="/:userIdentifier" element={<Home />}></Route>
            <Route path="/:userIdentifier/share" element={<ShareResume />}></Route>
        </Routes>
    )
}

export default MainNavigator